// Note: this component is meant to be used outside of the application lifecycle. I cannot depend on Fenrir/i18n or any other application/platform code.
export const LoadingWolf = () => (
  <svg
    height="100"
    viewBox="0 0 112 93"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
      {`
        @media (prefers-reduced-motion: reduce) {
          .loading-wolf-gradient-start {
            stop-color: #83D6FF !important;
          }
          .loading-wolf-gradient-end {
            stop-color: #0059B2 !important;
          }
        }
      `}
    </style>
    <defs>
      <clipPath id="triangle">
        <path d="M60.0882 0L119.722 100H0.45396L60.0882 0Z" fill="green" />
      </clipPath>
      <linearGradient id="promo-gradient" gradientTransform="rotate(90)">
        <stop
          className="loading-wolf-gradient-start"
          offset="0%"
          stopColor="#83D6FF"
        >
          <animate
            attributeName="stop-color"
            values="#83D6FF; #0059B2; #83D6FF"
            dur="4s"
            repeatCount="indefinite"
          ></animate>
        </stop>

        <stop
          className="loading-wolf-gradient-end"
          offset="100%"
          stopColor="#0059B2"
        >
          <animate
            attributeName="stop-color"
            values="#00244C; #83D6FF; #00244C;"
            dur="4s"
            repeatCount="indefinite"
          ></animate>
        </stop>
      </linearGradient>
    </defs>

    <path fill="transparent" d="M111.7 92.4L56 .3.2 92.4" />
    <g fill="url(#promo-gradient)">
      <path d="M64.5 36.9l1.1 7-2 8.1 4.6-2.5-1.1-8.9-2.6-3.7zM44.1 74.4l-4.2 2.3-7.2.6 7.3 1c0-.1 4.1-3.9 4.1-3.9zm2.8-15.8l4.6-4-.3-3.3-4.3 7.3zm24.5 2.8l.2-5.6-1 2.2.8 3.4z" />
      <path d="M44.1 74.4l-4.2 2.3-7.2.6 7.3 1c0-.1 4.1-3.9 4.1-3.9zm2.8-15.8l4.6-4-.3-3.3-4.3 7.3zm17.6-21.7l1.1 7-2 8.1 4.6-2.5-1.1-8.9-2.6-3.7z" />
      <path d="M24.8 87.9l4-3.7 3.9-7.1-6.2-1.3 9.9-8.5 1.9-3.8 3.2-4.3 3.3-6.1 3.2-3.5 5.3-2.2 7.2-14.3 4.6 2.8 2.9 3.6 1.7 9 3.4-4 2.1 1 .4 2.4-1.4 8-2.5 6.5 2.1 10.7-1.8-.4 1.7 5.5-1.3-.1 2.1 6.9-2.2-.8 2.8 6.3.5 1.9h36.1L55.9.1.1 92.4h21.8l4.4-4.6-1.5.1z" />
      <path d="M71.4 61.4l.2-5.6-1 2.2.8 3.4z" />
    </g>
  </svg>
);
